import { useEffect, useState } from 'react';
import api from '../../api/axios';

const EMPTY = { year: '', title: '', description: '', display_order: 0 };

export default function MilestonesManager() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);

  const load = () => {
    setLoading(true);
    api.get('/milestones').then(r => setItems(r.data || [])).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const openAdd = () => { setEditing(null); setForm(EMPTY); setError(''); setShowForm(true); };
  const openEdit = m => { setEditing(m.id); setForm({ year: m.year, title: m.title, description: m.description || '', display_order: m.display_order || 0 }); setError(''); setShowForm(true); };

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      if (editing) await api.put(`/milestones/${editing}`, form);
      else await api.post('/milestones', form);
      setShowForm(false);
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this milestone?')) return;
    await api.delete(`/milestones/${id}`);
    load();
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div><h4 className="fw-bold mb-0">Milestones</h4><p className="text-muted small mb-0">Track community achievements over the years</p></div>
        <button className="btn btn-primary rounded-pill px-4" onClick={openAdd}><i className="fas fa-plus me-2"></i>Add Milestone</button>
      </div>

      {showForm && (
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-body p-4">
            <h5 className="fw-bold mb-4">{editing ? 'Edit Milestone' : 'Add Milestone'}</h5>
            {error && <div className="alert alert-danger py-2">{error}</div>}
            <form onSubmit={save}>
              <div className="row g-3">
                <div className="col-md-3"><label className="form-label small">Year *</label><input name="year" value={form.year} onChange={handle} required className="form-control" placeholder="e.g. 2024" /></div>
                <div className="col-md-6"><label className="form-label small">Title *</label><input name="title" value={form.title} onChange={handle} required className="form-control" /></div>
                <div className="col-md-3"><label className="form-label small">Display Order</label><input name="display_order" type="number" value={form.display_order} onChange={handle} className="form-control" /></div>
                <div className="col-12"><label className="form-label small">Description</label><textarea name="description" value={form.description} onChange={handle} rows="2" className="form-control"></textarea></div>
              </div>
              <div className="d-flex gap-2 mt-4">
                <button type="submit" disabled={saving} className="btn btn-primary rounded-pill px-4">{saving ? 'Saving...' : 'Save'}</button>
                <button type="button" className="btn btn-outline-secondary rounded-pill px-4" onClick={() => setShowForm(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {loading ? <div className="text-center py-5"><div className="spinner-border text-primary"></div></div> : (
        <div className="card border-0 shadow-sm">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light"><tr><th>Year</th><th>Title</th><th>Description</th><th></th></tr></thead>
              <tbody>
                {items.length === 0 && <tr><td colSpan="4" className="text-center text-muted py-4">No milestones yet.</td></tr>}
                {items.map(m => (
                  <tr key={m.id}>
                    <td><strong className="text-primary">{m.year}</strong></td>
                    <td>{m.title}</td>
                    <td className="text-muted small">{m.description?.substring(0, 80)}{m.description?.length > 80 ? '...' : ''}</td>
                    <td>
                      <button className="btn btn-sm btn-outline-primary me-2" onClick={() => openEdit(m)}>Edit</button>
                      <button className="btn btn-sm btn-outline-danger" onClick={() => remove(m.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
